"use client";

import { useState } from "react";
import { useTranslations } from "use-intl";

import { HiddenIcon, VisibleIcon } from "@/components/appIcons";
import { cn } from "@/lib/utils";

import { Input } from "./ui/input";

export function PasswordInput({ className, ...props }: React.ComponentProps<"input">) {
  const [visible, setVisible] = useState(false);
  const ta = useTranslations("globals.accessibility");
  const Icon = visible ? HiddenIcon : VisibleIcon;

  return (
    <div className="relative">
      <Input {...props} type={visible ? "text" : "password"} className={cn("pr-10", className)} />
      <button
        type="button"
        aria-label={ta(visible ? "hidePassword" : "showPassword")}
        aria-pressed={visible}
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        className="absolute right-0 top-0 h-full px-3 rounded-r-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200"
      >
        <Icon className="text-base" />
      </button>
    </div>
  );
}
